import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-row-reverse" }
const _hoisted_2 = { class: "d-flex flex-row-reverse" }
const _hoisted_3 = { class: "d-flex align-items-center py-5" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center py-5"
}
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-items-center py-5"
}
const _hoisted_6 = { class: "row g-5 g-xl-8" }
const _hoisted_7 = { class: "col-xl-2" }
const _hoisted_8 = { class: "col-xl-2" }
const _hoisted_9 = { class: "col-xl-2" }
const _hoisted_10 = { class: "col-xl-2" }
const _hoisted_11 = { class: "col-xl-2" }
const _hoisted_12 = { class: "col-xl-2" }
const _hoisted_13 = { class: "row g-5 g-xl-8" }
const _hoisted_14 = { class: "col-xl-3" }
const _hoisted_15 = { class: "col-xl-3" }
const _hoisted_16 = { class: "col-xl-3" }
const _hoisted_17 = { class: "col-xl-3" }
const _hoisted_18 = { class: "row g-5 g-xl-8 my-2" }
const _hoisted_19 = { class: "col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Widget = _resolveComponent("Widget")!
  const _component_List = _resolveComponent("List")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("b", null, "Son Sipariş Verisi Güncellenme Tarihi: " + _toDisplayString(_ctx.getFormattedValue(_ctx.lastUpdateDate, "datetime")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.monthOrYear,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.monthOrYear) = $event)),
          class: "mx-5",
          "active-text": "Yıllık",
          "inactive-text": "Aylık"
        }, null, 8, ["modelValue"])
      ]),
      (!_ctx.monthOrYear)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.filters.startDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.startDate) = $event)),
              type: "month",
              placeholder: "Tarih Seç",
              format: "MM.YYYY",
              onChange: _ctx.onChangeDate
            }, null, 8, ["modelValue", "onChange"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.monthOrYear)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.filters.startEndDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.startEndDate) = $event)),
              type: "monthrange",
              "range-separator": "To",
              "start-placeholder": "Başlangış Ay",
              "end-placeholder": "Bitiş Ay",
              onChange: _ctx.onChangeDate
            }, null, 8, ["modelValue", "onChange"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen032.svg",
          color: "white",
          "icon-color": "primary",
          title: _ctx.datas.totalPayment,
          description: "Aylık Toplam Satışlar"
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen030.svg",
          color: "info",
          "icon-color": "white",
          title: _ctx.datas.newRestourantCount,
          description: "Yeni Restoran Sayısı"
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen001.svg",
          color: "secondary",
          "icon-color": "warning",
          title: _ctx.datas.totalRestourantCount,
          description: "Toplam Restoran Sayısı"
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen001.svg",
          color: "warning",
          "icon-color": "white",
          title: _ctx.datas.totalOrderCount,
          description: "Toplam Sipariş Sayısı"
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen001.svg",
          color: "danger",
          "icon-color": "white",
          title: _ctx.datas.totalIncome,
          description: "Toplam Gelecek Para"
        }, null, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Widget, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "svg-icon": "media/icons/duotune/general/gen001.svg",
          color: "success",
          "icon-color": "white",
          title: _ctx.datas.totalIncomePaid,
          description: "Toplam Gelen Para"
        }, null, 8, ["title"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_List, {
          id: "totalPaymentListId",
          title: "En Çok Sipariş Alan Şirketler",
          scroll: true,
          items: _ctx.datas.totalPaymentList,
          onShowAllClick: _ctx.showAllClick,
          modalItems: _ctx.modalList.list,
          modalHeader: _ctx.modalHeader
        }, null, 8, ["items", "onShowAllClick", "modalItems", "modalHeader"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_List, {
          id: "notOrderCompanyId",
          title: "Gün Bazında Sipariş Almayan Şirketler",
          scroll: true,
          items: _ctx.datas.notOrderCompany,
          onShowAllClick: _ctx.showAllClick,
          modalItems: _ctx.modalList.list,
          modalHeader: _ctx.modalHeader
        }, null, 8, ["items", "onShowAllClick", "modalItems", "modalHeader"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_List, {
          id: "companyOrderAvgId",
          title: "En Verimli Şirketler",
          scroll: true,
          items: _ctx.datas.companyOrderAvg,
          onShowAllClick: _ctx.showAllClick,
          modalItems: _ctx.modalList.list,
          modalHeader: _ctx.modalHeader
        }, null, 8, ["items", "onShowAllClick", "modalItems", "modalHeader"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (!_ctx.monthOrYear)
          ? (_openBlock(), _createBlock(_component_List, {
              key: 0,
              id: "companyPaymentsId",
              title: "Ödemesi Olan Şirketler",
              scroll: true,
              items: _ctx.datas.companyPayments,
              onShowAllClick: _ctx.showAllClick,
              modalItems: _ctx.modalList.list,
              modalHeader: _ctx.modalHeader,
              modalSubTitle: "sum",
              modalSubTitleSign: _ctx.currencySymbol,
              subtitle: 
          'Toplam: ' +
          _ctx.currencyFormat(
            _ctx.datas.companyPayments
              .map((s) => s.rawValue)
              .reduce((a, b) => a + b, 0),
            true
          )
        
            }, null, 8, ["items", "onShowAllClick", "modalItems", "modalHeader", "modalSubTitleSign", "subtitle"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Chart, {
          title: "Günlük Satışlar",
          categories: _ctx.datas.dailyPayment.categories,
          series: _ctx.datas.dailyPayment.series
        }, {
          toolbar: _withCtx(() => [
            (_ctx.monthOrYear)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", { active: _ctx.filters.chartDateType == 3 }]),
                  id: "kt_charts_widget_gun",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chartDateTypeClick(3)))
                }, "Ay", 2))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", { active: _ctx.filters.chartDateType == 0 }]),
              id: "kt_charts_widget_gun",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.chartDateTypeClick(0)))
            }, "Gün", 2),
            _createElementVNode("a", {
              class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", { active: _ctx.filters.chartDateType == 1 }]),
              id: "kt_charts_widget_hafta",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.chartDateTypeClick(1)))
            }, "Hafta", 2),
            _createElementVNode("a", {
              class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4", { active: _ctx.filters.chartDateType == 2 }]),
              id: "kt_charts_widget_saat",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.chartDateTypeClick(2)))
            }, "Saat", 2)
          ]),
          _: 1
        }, 8, ["categories", "series"])
      ])
    ])
  ], 64))
}